import { useCallback } from "react"
import { readContract } from "wagmi/actions"
import { config } from "../lib/wagmi"
import { newPool } from "../utils/contract"
import { formatEther, parseEther } from "viem"



export const useOwner = ()=>{
    const owner =  useCallback (async (contractAddress)=>{

        const owner = await readContract(
            config,{
            address:contractAddress,
            abi:newPool.abi,
            functionName:"owner",
            }
        )
        return formatEther(owner)
    },[])

    return {owner}
}